import React, { useState } from 'react';
import {
    Box,
    Typography,
    Radio,
    RadioGroup,
    FormControlLabel,
    FormControl,
    FormLabel,
    Divider
} from '@mui/material';
import { useEffect } from 'react';
import { generatePresignedUrlForProcessContentAccess } from '../../helper/content_helper';

const ExamQuestions = ({ question, questionNumber, totalQuestions, answers, setAnswers }) => {
    const [presignedImageUrl, setPresignedImageUrl] = useState(null);

    useEffect(() => {
        console.log("question ", question);
        setPresignedImageUrl(null);
        const fetchPresignedUrl = async () => {
            if (question?.imageUrl) {
                try {
                    const response = await generatePresignedUrlForProcessContentAccess({
                        name: question.imageUrl,
                        type: "image"
                    });
                    if (response?.success) {
                        setPresignedImageUrl(response.presignedUrl);
                    } else {
                        console.error('Error generating pre-signed URL for', question.imageUrl);
                    }
                } catch (err) {
                    console.error('Presigned URL fetch error:', err);
                }
            }
        };

        fetchPresignedUrl();
    }, [question?.imageUrl]);
    const handleAnswerChange = (questionId, value) => {
        setAnswers(prev => ({
            ...prev,
            [questionId]: parseInt(value)
        }));
    };



    return (
        <Box>
            <FormControl component="fieldset" fullWidth>
                <FormLabel component="legend">
                    <Typography variant="h6">
                        Question {questionNumber} of {totalQuestions}: {question.questionText}
                    </Typography>
                </FormLabel>

                {presignedImageUrl && (
                    <Box sx={{ my: 2 }}>
                        <img
                            src={presignedImageUrl}
                            alt="Question"
                            style={{ maxWidth: "100%", maxHeight: "300px", borderRadius: "8px" }}
                        />
                    </Box>
                )}

                <RadioGroup
                    value={(answers[question.id] - 1)?.toString() || ''} // Subtract 1 for display
                    onChange={(e) => handleAnswerChange(question.id, parseInt(e.target.value) + 1)} // Add 1 for storage
                    sx={{ mt: 2 }}
                >
                    {[
                        question.option1,
                        question.option2,
                        question.option3,
                        question.option4
                    ].map((option, i) => (
                        option && (
                            <FormControlLabel
                                key={i}
                                value={i.toString()} // Still use 0-based index for the radio values
                                control={<Radio />}
                                label={option}
                                sx={{ mb: 1 }}
                            />
                        )
                    ))}
                </RadioGroup>
            </FormControl>

            <Divider sx={{ mt: 3, mb: 2 }} />

            <Typography variant="body2" color="text.secondary">
                Select one option above. You can change your answer later.
            </Typography>
        </Box>
    );
};

export default ExamQuestions;
